

    function addToProject(quantity, variantId, price, properties) {
    const myCart =
      document.querySelector('cart-drawer')
    const propertiesObj = {};
    properties.forEach((property) => {
      propertiesObj[property.name] = property.value;
    });
    propertiesObj.variant_id = variantId

    // console.log(myCart, variantId, price, properties,propertiesObj);

    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity,
            id: variantId,
            image: propertiesObj["variant image"],
            price: propertiesObj.price,
            properties: propertiesObj,
          },
        ],

        sections: "cart-drawer,cart-icon-bubble",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        myCart.renderContents(response);
        myCart.classList.remove("is-empty");

        return response;
      })
      .catch((error) => {
        console.error("Error:", error);
        // location.reload();
        // TODO: open the cart drawer
      });

  }

  class AddToQuoteButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        addToProject(
          1,
          event.target.dataset.variant,
          event.target.dataset.price,
          JSON.parse(document.getElementById(event.target.dataset.properties).textContent)
        ).then((response) => {
          // console.log(response);
        });
      });
    }
  }

  customElements.define('add-to-quote-btn', AddToQuoteButton);
